<template>
  <div class="fill-height">
    <div class="matchMaking   fill-height">
      <v-stepper
          class="fill-height"
          v-model="stepper" elevation="0">
        <v-stepper-items class="fill-height">
          <v-stepper-content step="1">
            <div class="questionArea">
              <div class="questionItem text-center">
                <div class="titleQuestionItem">
                  از دغدغه‌هایت بگو!
                </div>
                <div class="descQuestionItem">
                  برامون بگو این روزها در گیر چی هستی و چرا می خوای با یه درمانگر صحبت کنی
                </div>
                <div class="greenBox mt-5 d-flex">
                  <div class="ml-4 d-flex flex-column justify-center">
                    <img src="../../assets/image/user-journey/info-circle.svg" alt="">
                  </div>
                  <div>
                    این اطلاعات تنها برای پیشنهاد مشاور استفاده می‌شوند و بعد از آن به طور کامل از سیستم حذف خواهند شد.
                  </div>
                </div>
                <div class="filedArea mt-10">
                  <v-form ref="cc">
                    <v-textarea v-model="cc" height="190" style="margin:0px auto "
                                :rules="requiredRulesTextArea"
                                outlined
                                placeholder="برای مثال: چند ساله بعد از فوت پدرم، حالم خوب نیست انگار دیگه خوشحال نیستم. البته کار هام هم خیلی بهم ریخته شده و تا میام یه کار جدید انجام بدم مدام بدنم یخ میکنه و لرزش دست دارم و استرس تمام وجودمو گرفته. بقیه میگن خیلی حساس شدم چون سعی میکنم همه چیز رو چند بار چک کنم و از نظرم هیچی تمیز نیست و باید چند بار بشورم. اما این خودم رو هم کلافه کرده حتی دیگه اشتها غذا خوردن رو هم ندارم چون سختمه مطمئن بشم ظرف ها خوب تمیز هستن یا نه."></v-textarea>

                    <div class="hintAreaAuth justify-space-between d-flex">
                      <div class="d-flex">
                        <div>
                          <img src="../../assets/image/user-journey/info.svg" width="16px" alt="">
                        </div>
                        <div class="mr-1 d-flex justify-center flex-column">
                          <div>
                            لطفا
                            <b>
                              حداقل
                              100
                            </b>
                            کاراکتر بنویسید
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-column justify-center">
                        {{ cc.length }}/50
                      </div>
                    </div>
                  </v-form>
                </div>
                <div class="actionArea">
                  <v-btn elevation="0" block class="nextQuestion" @click="saveCC">
                    سوال بعد
                  </v-btn>
                </div>
              </div>
            </div>
          </v-stepper-content>
          <v-stepper-content step="2" class=" fill-height">
            <div class="questionArea fill-height">
              <div class="questionItem text-center">
                <div class="titleQuestionItem">
                  جنسیت درمانگر خود را انتخاب کنید.
                </div>

                <div class="filedArea mt-5">
                  <v-row class="pa-0 ma-0">
                    <v-col cols="12" lg="12" class="pa-0 ma-0" v-for="(item , i) in genders" :key="i">
                      <div class="optionItem " :style="$vuetify.breakpoint.mdAndUp && 'margin:10px'"
                           @click="setGender(item.value)"
                           :class="gender == item.value && 'activeOption'">
                        {{ item.title }}
                      </div>
                    </v-col>
                  </v-row>
                </div>

              </div>
            </div>
          </v-stepper-content>
          <v-stepper-content step="3">
            <div class="questionItem">
              <div class="titleQuestionItem">
                چه روزهایی را برای جلسه تراپی ترجیح می‌دهید؟
              </div>
              <div class="descQuestionItem">
                (امکان انتخاب بیش از یک گزینه وجود دارد)
              </div>
              <div class="greenBox mt-5 d-flex">
                <div class="ml-4">
                  <img src="../../assets/image/user-journey/info-circle.svg" alt="">
                </div>
                <div>
                  هرچه زمان‌های منعطف‌تری وارد کنید، شانس هماهنگی سریع‌تر و دقیق‌تر با درمانگر بیشتر می‌شه
                </div>
              </div>
              <div class="filedArea mt-10">
                <div v-for="(item, i) in times" :key="i" @click="setTime(item.value)">
                  <div
                      class="optionItem d-flex flex-row justify-start"
                      :class="time.includes(item.value) ? 'activeOption' : ''"
                  >
                    <div>
                      <v-checkbox
                          @click="setTime(item.value)"
                          style="margin-top: -5px"
                          v-model="time"
                          :value="item.value"
                          hide-details
                      ></v-checkbox>
                    </div>
                    <div>
                      {{ item.title }}
                    </div>
                  </div>
                </div>


                <div class="mt-5">
                  <v-fade-transition>
                    <v-form ref="custom">
                      <v-textarea v-model="time_desc"
                                  :rules="requiredRules"
                                  v-if="time == 'custom'" height="190" style="margin:0px auto "
                                  outlined
                                  placeholder="مثلا: برنامه کاری من به صورت هفتگی تغییر میکند">
                      </v-textarea>
                    </v-form>
                  </v-fade-transition>

                </div>

              </div>
              <div class="actionArea mt-8">
                <v-btn elevation="0" block class="nextQuestion" @click="saveTime">
                  سوال بعد
                </v-btn>
              </div>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import {resolveJourneyToken} from "@/utils/journeyToken";

export default {
  data() {
    return {
      stepper: 1,
      requiredRulesTextArea: [
        v => !!v || "",
        v => (v && v.length >= 50) || "",
      ],
      cc: "",
      gender: null,
      time: [],
      time_desc: null,
      times: [
        {
          title: 'من برنامه‌ی انعطاف‌پذیری دارم و اکثر زمان‌ها برای جلسات درمانی مناسب است.',
          value: 'flexible',
        },
        {
          title: 'دوشنبه تا جمعه – ساعات اداری (۰۹:۰۰ تا ۱۷:۰۰)',
          value: 'weekday_daytime',
        },
        {
          title: 'دوشنبه تا جمعه – خارج از ساعات اداری (بعد از ۱۷:۰۰)',
          value: 'weekday_evening',
        },
        {
          title: 'شنبه و یک شنبه – صبح تا عصر (۰۹:۰۰ تا ۱۷:۰۰)',
          value: 'weekend',
        },
        {
          title: 'شنبه و یک شنبه – عصر و شب (بعد از ۱۷:۰۰)',
          value: 'evening_or_weekend',
        },

        {
          title: 'هر هفته به زمان‌های متفاوتی نیاز دارم',
          value: 'custom',
        },
      ],
      genders: [
        {
          title: 'زن',
          value: 'FEMALE'
        },
        {
          title: 'مرد',
          value: 'MALE'
        },
        {
          title: 'تفاوتی ندارد',
          value: 'OTHER'
        },
      ]
    }
  },
  mounted() {
    // this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', 1)
    this.$onEvent('changeStepMatchmaking', (step) => {
      this.stepper = step
    })
    this.$onEvent('backInMatchMaking', () => {
      if (this.stepper == 1) {
        window.location = 'https://simiaroom.com'
      } else {
        this.stepper--
      }
    })

  },
  watch: {},
  methods: {
    setGender(gender = null) {
      this.gender = gender
      this.stepper++
    },
    setTime(value) {
      const index = this.time.indexOf(value);

      if (index !== -1) {
        this.time.splice(index, 1); // remove if exists
      } else {
        this.time.push(value);      // add if not exists
      }
    },
    saveCC() {
      if (this.$refs.cc.validate()) {
        this.stepper++
      }
    },
    saveTime() {
      if (!this.time) {
        this.$emitEvent("notify", {
          title: "یک زمان انتخاب کنید",
          color: "red",
        });
      } else if (this.time == 'custom') {
        if (this.$refs.custom.validate()) {
          this.getDoctors()
        }
      } else {
        this.getDoctors()
      }
      return;
    },
    getDoctors() {

      let payload = {
        cc: this.cc,
        gender: this.gender,
        time: this.time,
        time_description: this.time_desc,
        token: resolveJourneyToken(),
      }
      if (this.$store.getters.getIsLoggedIn) {
        // this.$emitEvent('setLoading', true)
        this.$emit('changeStateFlow', {
          state: 'mm_submit'
        })
        this.$emitEvent('setLoading', true)
        this.requesting('match_making', 'suggestDoctor', {}, payload).then((resp) => {

          //
          if (resp.message != "exclude") {
            this.$emitEvent('setTherapists', resp.data.therapists)
          } else {
            this.$emitEvent('excludeUser')
          }
        }).finally(() => {
          this.$emitEvent('setLoading', false)
        })
      } else {
        this.$emit('changeStateFlow', {
          state: 'mm_submit'
        })
        this.$store.commit('SET_MATCH_MAKING_DATA', payload)
      }

    }
  },
}
</script>

<style scoped>

@media (min-width: 200px) and (max-width: 1000px) {
  .matchMaking {
    margin-top: 10px !important;
  }

  .titleQuestionItem {
    font-size: 20px !important;
  }

  .descQuestionItem {
    font-size: 16px !important;
  }

  .questionArea {
    width: 100% !important;
  }

  .greenBox {
    font-size: 14px !important;
    padding: 8px !important;
  }

  .optionItem {
    min-height: 80px !important;
    margin-bottom: 10px !important;
    font-size: 15px !important;
  }

  .nextQuestion {
    position: fixed;
    bottom: 0px;
    right: 0px;
    left: 0px;
    border-radius: 0px !important;
  }
}

.optionItem {
  display: flex;
  height: 60px;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 8px;
  border: 1px solid #E1E1E1;
  background: #FFF;
  transition: all 0.3s;
  cursor: pointer;
  margin-bottom: 13px;
}

.optionItem:hover {
  transition: all 0.3s;
  border-color: #39C990 !important;
  background: linear-gradient(180deg, #FFF 0%, rgba(215, 244, 233, 0.80) 100%) !important;
}

.activeOption {
  border: 1px solid #39C990;
  background: linear-gradient(180deg, #FFF 0%, rgba(215, 244, 233, 0.80) 100%) !important;
}

.questionArea {
  width: 90%;
  margin: 0px auto;
}

.matchMaking * {
  direction: rtl !important;
}

.matchMaking {
  margin-top: 50px;
}

.titleQuestionItem {
  color: #212121;
  text-align: center;
  /* Title/Large/Bold24 */
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.descQuestionItem {
  color: #212121;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 10px;
}

.greenBox {
  color: #30A778;
  text-align: right;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  border-radius: 8px;
  border: 1px solid #39C990;
  background: rgba(215, 244, 233, 0.50);
  border-radius: 8px;
  padding: 14px 16px;

}

.nextQuestion {
  border-radius: 8px;
  background: #39C990 !important;
  color: white;
  height: 48px !important;
  font-weight: 700;
  font-size: 16px;
}

.hintAreaAuth {
  color: #616161;
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin-top: -20px;
}

</style>